import { render, staticRenderFns } from "./modal-proof-created.vue?vue&type=template&id=1ef91e16&scoped=true&"
import script from "./modal-proof-created.vue?vue&type=script&lang=js&"
export * from "./modal-proof-created.vue?vue&type=script&lang=js&"
import style0 from "./modal-proof-created.vue?vue&type=style&index=0&id=1ef91e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef91e16",
  null
  
)

export default component.exports